import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PlayerNotes } from 'src/app/models/PlayerNotes.model';
import { Observable } from 'rxjs';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class PlayerNotesService {
  constructor(
    private http: HttpClient,
    private storage: StorageService
  ) { }

  getNotes(scheduleGameID: number) : Observable<PlayerNotes[]> {
    const url = environment.PRESSROOM_API_URL + `scheduledGames/${scheduleGameID}/playerNotes`;

    return this.http.get(url).pipe(
      map((data: any) => {
        if (data) {
          var playerNotes: PlayerNotes[] = [];
          data.forEach(note => {
            var playerNote = new PlayerNotes(note);
            playerNotes.push(playerNote);
          });
          return playerNotes;
        } else {
          return null;
        }
      })
    );
  }

  getNotesByPlayerID(scheduleGameID: number, playerID: number): Observable<PlayerNotes> {
    const params = {
      player_id: playerID
    }

    const url = environment.PRESSROOM_API_URL + `scheduledGames/${scheduleGameID}/playerNotes?parameters=` + JSON.stringify(params);

    return this.http.get(url).pipe(
      map((data: any) => {
        if (data != false) {
          if (data) {
            var playerNotes = new PlayerNotes(data);
            return playerNotes;
          } else {
            var playerNotes = new PlayerNotes();
            return playerNotes;
          }
        } else {
          return null;
        }
      })
    );
  }

  addPlayerNotes(notes: PlayerNotes[], scheduledGameID: number) {
    let body = {
      player_notes: notes,
      scheduled_game_id: scheduledGameID
    };

    const url = environment.PRESSROOM_API_URL + `/scheduledGames/${scheduledGameID}/playerNotes`;

    return this.http.post(url, body).pipe(
      map((data: any) => { return data; })
    );
  }

  saveNotesFromLocalStorage(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.storage.get('playerNotes').then((savedNotes: any) => {
        if (savedNotes) {
          let playerNotes: PlayerNotes[] = [];
          savedNotes.playerNotes.forEach(note => {
            playerNotes.push(new PlayerNotes(note));
          });

          this.addPlayerNotes(playerNotes, savedNotes.scheduledGameID).subscribe(() => {
            this.storage.remove('playerNotes');
            resolve(true);
          });
        } else {
          resolve(true);
        }
      }).catch(() => {
        resolve(false);
      });
    });
  }

  saveNotesToStorage(notes: PlayerNotes, scheduledGameID: number): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let body = notes.toJSON();

      this.storage.get('playerNotes').then((savedNotes: any) => {
        if (savedNotes) {
          savedNotes.scheduledGameID = scheduledGameID;
          savedNotes.playerNotes.push(body);
          this.storage.set("playerNotes", savedNotes);
          resolve(true);
        } else {
          this.storage.set("playerNotes", { 
            scheduledGameID: scheduledGameID, 
            playerNotes: [body] 
          });
          resolve(true);
        }
      });
    });
  }

  bulkSaveNotesToStorage(notes: PlayerNotes[], scheduledGameID: number): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let playerNotes = [];
      notes.forEach(note => {
        playerNotes.push(note.toJSON());
      });

      this.storage.set("playerNotes", { 
        scheduledGameID: scheduledGameID, 
        playerNotes: playerNotes 
      }).then(() => {
        resolve(true);
      }).catch(() => {
        resolve(false);
      });
    });
  }
}
